import { Component, OnInit } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    imports: [MatProgressSpinner]
})
export class NotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}


